// import React from 'react';
import swal from "sweetalert";
import { CONSTANTS } from "./constants";

async function handleErrors(response) {
	console.log(response);
	if (response.status !== 200) {
		if (response.status === 401) {
			localStorage.removeItem(CONSTANTS.POWER_METER);
			swal('Unauthorized!', 'Please login again', 'error');
			window.location.href = "/login";
		} else {
			return response;
		}

		throw Error(response.statusText);
	}
	return response;
}
function Api() {

	const Login = (token, name, role) => {
		localStorage.setItem(CONSTANTS.POWER_METER, token);
		localStorage.setItem(CONSTANTS.NAME, name);
		localStorage.setItem(CONSTANTS.ROLE, role);
	}

	const LogOut = () => {
		localStorage.removeItem(CONSTANTS.POWER_METER);
		localStorage.removeItem(CONSTANTS.NAME);
		localStorage.removeItem(CONSTANTS.ROLE);
	}

	const isAuthenticated = () => {
		return localStorage.getItem(CONSTANTS.POWER_METER);
	}

	const getRole = () => {
		return localStorage.getItem(CONSTANTS.ROLE);
	}

	const isWaterIOT = (imei) => {
		if (["863406074374617"].includes(imei)) {
			return true;
		}
		return false;
	}

	const doFetch = async (type, data, url) => {
		let reqData = { ...data };
		const token = localStorage.getItem(CONSTANTS.POWER_METER);
		if (data === null || data === undefined) { reqData = {}; }
		return fetch(url, {
			method: type,
			headers: type !== 'GET' && type !== 'DELETE' ? {
				'Authorization': `Bearer ${token}`,
				'content-type': 'Application/json'
			}
				: {
					'Authorization': `Bearer ${token}`,
				},
			body: type !== 'GET' && type !== 'DELETE' ? JSON.stringify({ ...reqData }) : null,
		})
			.then(handleErrors)
			.then(res => res.json())
			.catch(err => console.log(err));
	};

	return {
		Login,
		LogOut,
		isAuthenticated,
		doFetch,
		getRole,
		isWaterIOT
	};
}
export default new Api();